import { Link } from "react-router-dom";

export const PrimaryButton = ({ children, route = "/auth/signin" }) => {
    return (
        <Link to={route} className="relative z-20">
            <button className="w-full md:w-[170px] h-[56px] flex items-center justify-center font-semibold rounded-lg bg-primary-main hover:bg-primary-hover leading-[19.83px] text-md text-neutral-10">{children}</button>
        </Link>
    );
};

export const SurfaceButton = ({ children, route = "/pricing" }) => {
    return (
        <Link to={route} className="relative z-20">
            <button className="w-full md:w-[170px] h-[56px] flex items-center justify-center font-semibold rounded-lg text-primary-main text-md leading-[19.83px] bg-primary-surface">{children}</button>
        </Link>
    );
};